// extracted by mini-css-extract-plugin
module.exports = {"modalBackdrop":"Menu_modalBackdrop__EVQvN","menuIcon":"Menu_menuIcon__QU3Hd","menuItem":"Menu_menuItem__3or_u","menuItemText":"Menu_menuItemText__2P8oM"};